module.exports = __webpack_public_path__ + "static/media/lmv.65f55208.jpg";